<template>

    <div>
    
    
        <!--<label class="file-label" for="headshot">点击上传头像</label>-->
        <input autocomplete="off" type="file" accept="image/png, image/jpeg, image/jpg" id="headshot" class="from-file" @change="Headshot" required>
        <label class="img-label Face-label" for="headshot">
            <img class="from-img " :src="headshot"/>
        </label>
        <!--<div class="headshotTailor-box">
            <div class="headshotTailor">
                <div class="cropper-box">
                    <vueCropper
                        ref="cropper"
                        :img="example2.img"
                        :outputSize="example2.size"
                        :outputType="example2.outputType"
                        :info="example2.info"
                        :canScale="example2.canScale"
                        :autoCrop="example2.autoCrop"
                        :autoCropWidth="example2.autoCropWidth"
                        :autoCropHeight="example2.autoCropHeight"
                        :fixedBox="example2.fixedBox"
                        @mouseover="scaleImg"
                    ></vueCropper>
                </div>
                
                <div class="cropperBtn" @click="finish('blob')">裁切</div>
                <span></span>
            </div>-->
        </div>
    </div>
</template>
<script>
import vueCropper from 'vue-cropper'
export default {
    name: 'top',
    data () {
        return {
            headshot:'',
            headshotFile:'',

            // example2: {
			// 	img: '',
			// 	info: true,
			// 	size: 1,
			// 	outputType: 'jpeg',
			// 	canScale: false,
            //     autoCrop: true,
			// 	// 只有自动截图开启 宽度高度才生效
			// 	autoCropWidth: 240,
			// 	autoCropHeight: 240,
			// 	// 开启宽度和高度比例
			// 	fixed: true,
			// 	fixedNumber: [4, 4]
			// }
            example2: {
				img: '',
                info: true,
				size: 1,
				outputType: 'jpeg',
				canScale: false,
				autoCrop: true,
				autoCropWidth: 240,
				autoCropHeight: 240,
				fixedBox: true,
			}
        }
    },
    props:['Face'],
    watch:{
        Face:function(val) {
            this.headshot=val;
        }
    },
    methods:{
        Headshot(event){ //图片添加
            let file = event.target.files[0],
            reader = new FileReader(),
            formData = new FormData(),
            image = new Image(),
            value = event.target.value,
            self = this,
            width,
            height,
            size;
            if(file){
                if (/^image\/png/.test(file.type) || /^image\/jpeg/.test(file.type)){
                // self.file=file;
                    reader.onload = function(e){ 
                        let result = e.target.result;
                        
                        //加载图片获取图片真实宽度和高度 
                        image.onload=function(e){  
                            width = image.width;  
                            height = image.height;
                            size = file.size;

                            if(width<260 || height<260){
                                self.$layer.msg('图片大小应大于240px*240px!');
                            }else{
                                // $('.headshotTailor-box').show();
                                // $(event.target).siblings('.img-label').show().siblings('.file-label').hide();
                                self.headshot=result;
                                self.headshotFile=file;
                                self.$emit('FaceImg',file);//传值
                            }
                        };  
                        image.src= result; 
                        
                        // if(self.imgList.length<1){
                        //     if(self.imgList.indexOf(result) == -1){ 
                        //         self.imgList.push(result);
                        //         value = '';
                        //         self.file=file;
                        //         // console.log(self.imgList)
                        //         // self.thenewproduct.coImage=self.imgList.length;
                        //     }else{// 已存在
                        //         self.$layer.msg('图片已存在！');
                        //     }
                        // }else{
                        //     self.$layer.msg('主图限制9张以内！');
                        // }
                        
                    }

                    reader.readAsDataURL(file);

                     
                    

                // formData.append('file', e.target.files[0]);
                // formData.append('type', 'test');
                }else if(/^image\/gif/.test(file.type)){
                    self.$layer.msg('不支持的图片格式！');
                }else{
                    self.$layer.msg('该文件不是图片！');
                }    
            }else{//没有选
                return;
            }
        },
        scaleImg () {
			this.support = "onwheel" in document.createElement("div") ? "wheel" : document.onmousewheel !== undefined ? "mousewheel" : "DOMMouseScroll"
			if (this.canScale) {
				window.addEventListener(this.support, this.changeSize)
			}
		},
        changeImg () {
			this.option.img = this.lists[~~(Math.random() * this.lists.length)].img
		},
		startCrop () {
			// start
			this.crap = true
			this.$refs.cropper.startCrop()
		},
		stopCrop () {
			//  stop
			this.crap = false
			this.$refs.cropper.stopCrop()
		},
		clearCrop () {
			// clear
			this.$refs.cropper.clearCrop()
		},
		// 实时预览函数
		realTime (data) {
			this.previews = data
		},
		finish (type) {
			// 输出
			// var test = window.open('about:blank')
            var self=this;
			this.$layer.msg('图片生成中..');
            $('.headshotTailor-box').hide();
            this.$refs.cropper.getCropBlob((data) => {
                self.headshotFile=data;
                self.$emit('FaceImg',data);//传值
            })
            this.$refs.cropper.getCropData((data) => {
                // self.Face=data;
            })
			// if (type === 'blob') {
			// 	this.$refs.cropper.getCropBlob((data) => {
			// 		var test = window.open('')
               
            //         test.location.href = window.URL.createObjectURL(data)
            //     })
			// } else {
			// 	this.$refs.cropper.getCropData((data) => {
			// 		test.location.href = data
			// 	})
			// }
		},

		down (type) {
			// event.preventDefault()
			var aLink = document.createElement('a')
			aLink.download = 'demo'
			// 输出
			if (type === 'blob') {
				this.$refs.cropper.getCropBlob((data) => {
					this.downImg = data
					aLink.href = data
					aLink.click()
				})
			} else {
				this.$refs.cropper.getCropData((data) => {
					this.downImg = data
					aLink.href = data
					aLink.click()
				})
			}
		},

		uploadImg (event, num) {
			//上传图片
			// this.option.img
			var file = event.target.files[0],
            self = this;
			if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(event.target.value)) {
				 self.$layer.msg('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
				 return false
			}
			var reader = new FileReader();
            var image = new Image();
            var widths;
            var heights;
			reader.onload = (e) => {
                let result = e.target.result;
                image.onload=(es) =>{  
                    widths = image.width;  
                    heights = image.height;
                    if(widths<240 || heights<240){
                        self.$layer.msg('图片大小应大于240px*240px!');
                        return false
                    } 
                    let data
                    if (typeof e.target.result === 'object') {
                        // 把Array Buffer转化为blob 如果是base64不需要
                        data = window.URL.createObjectURL(new Blob([e.target.result]))
                    } else {
                        data = result
                    }
                    this.example2.img = data
                    $('.headshotTailor-box').show();
                    $(event.target).siblings('.img-label').show().siblings('.file-label').hide();
                };  
                image.src= result; 
				
				
			}
			// 转化为base64
			reader.readAsDataURL(file)
			// 转化为blob
			// reader.readAsArrayBuffer(file)
		}
    },
    components: {
		vueCropper
	},
    mounted(){
        

        
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.headshotTailor-box{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    z-index: 11;
    display: none;
    .headshotTailor{
        position: relative;
        top: 50%;
        
        display: inline-block;
        margin: 0 auto;
        margin-top: -180px;
        height: 360px;
        min-width:1200px;
        background-color: #fff;
        padding: 20px;
        box-sizing: border-box;
        .cropper-box{
            height:242px;
        }
        .cropperBtn{
            display: inline-block;
            width: 100px;
            height: 40px;
            background: #ff8c00;
            color: #fff;
            border-radius: 6px;
            cursor: pointer;
            margin-top: 30px;
            line-height: 40px;
            text-align: center;
        }
        // .canvas-box{
        //     width: 640px; 
        //     position: relative;
        //     user-select:none;
        //     .overlay{ 
        //         position: absolute; 
        //         left: 0; 
        //         top: 0; 
        //         cursor: move;
        //         border:1px solid #69f;
        //     }
        //     div,canvas{
        //         user-select:none
        //     }
        // }
    }
}
.Face-label{
    display: block !important;
}
</style>


// WEBPACK FOOTER //
// src/components/public/headshot.vue